export enum ActionType {
  PRODUCTS_SAVE_DATA = "PRODUCTS_SAVE_DATA",
  SAVE_MARKET = "SAVE_MARKET",
  SAVE_FLAG_MARKET = "SAVE_FLAG_MARKET",
  SAVE_WIZARD = "SAVE_WIZARD",
  SAVE_WIZARD_ENABLE_NEXT = "SAVE_WIZARD_ENABLE_NEXT",
  SAVE_MACHINE_TONNAGE = "SAVE_MACHINE_TONNAGE",
  SAVE_PRODUCT_CATEGORY = "SAVE_PRODUCT_CATEGORY",
  SAVE_PRODUCT_MACHINE_FIXING_TYPE = "SAVE_PRODUCT_MACHINE_FIXING_TYPE",
  SAVE_PRODUCT_TOOLS_PRODUCT_TYPES = "SAVE_PRODUCT_TOOLS_PRODUCT_TYPES",
  SAVE_OPTIONAL_TOOLS_PRODUCT_TYPES = "SAVE_OPTIONAL_TOOLS_PRODUCT_TYPES",
  SAVE_OPTIONAL_TOOLS_IS_TOOLS_SELECTED = "SAVE_OPTIONAL_TOOLS_IS_TOOLS_SELECTED",
  SAVE_OPTIONAL_TOOLS_IS_TILTROTATORS_SELECTED = "SAVE_OPTIONAL_TOOLS_IS_TILTROTATORS_SELECTED",
  SAVE_OPTIONAL_TOOLS_IS_MACHINE_FIXINGS_SELECTED = "SAVE_OPTIONAL_TOOLS_IS_MACHINE_FIXINGS_SELECTED",
  SAVE_OPTIONAL_MACHINE_FIXING_TYPE = "SAVE_OPTIONAL_MACHINE_FIXING_TYPE",
  SAVE_CART_SELECTIONS_PRODUCT_TILTROTATOR = "SAVE_CART_SELECTIONS_PRODUCT_TILTROTATOR",
  SAVE_CART_SELECTIONS_PRODUCT_MACHINE_FIXING = "SAVE_CART_SELECTIONS_PRODUCT_MACHINE_FIXING",
  SAVE_CART_SELECTIONS_PRODUCT_UPPER_BRACKET = "SAVE_CART_SELECTIONS_PRODUCT_UPPER_BRACKET",
  SAVE_CART_SELECTIONS_PRODUCT_LOWER_BRACKET = "SAVE_CART_SELECTIONS_PRODUCT_LOWER_BRACKET",
  SAVE_CART_SELECTIONS_PRODUCT_GRAPPLE_MODULE = "SAVE_CART_SELECTIONS_PRODUCT_GRAPPLE_MODULE",
  SAVE_CART_SELECTIONS_PRODUCT_NO_GRAPPLE_MODULE_SELECTED = "SAVE_CART_SELECTIONS_PRODUCT_NO_GRAPPLE_MODULE_SELECTED",
  SAVE_CART_SELECTIONS_PRODUCT_TOOLS_PRODUCT_ITEMS = "SAVE_CART_SELECTIONS_PRODUCT_TOOLS_PRODUCT_ITEMS",
  SAVE_CART_SELECTIONS_OPTIONAL_TOOLS_PRODUCT_ITEMS = "SAVE_CART_SELECTIONS_OPTIONAL_TOOLS_PRODUCT_ITEMS",
  SAVE_CART_SELECTIONS_OPTIONAL_TILTROTATOR = "SAVE_CART_SELECTIONS_OPTIONAL_TILTROTATOR",
  SAVE_CART_SELECTIONS_OPTIONAL_MACHINE_FIXING = "SAVE_CART_SELECTIONS_OPTIONAL_MACHINE_FIXING",
  SAVE_CART_SELECTIONS_OPTIONAL_GRAPPLE_MODULE = "SAVE_CART_SELECTIONS_OPTIONAL_GRAPPLE_MODULE",
  SAVE_CART_SELECTIONS_OPTIONAL_NO_GRAPPLE_MODULE_SELECTED = "SAVE_CART_SELECTIONS_OPTIONAL_NO_GRAPPLE_MODULE_SELECTED",
  SAVE_CART_OPTIONAL_TOOLS_PRODUCT_ITEMS = "SAVE_CART_OPTIONAL_TOOLS_PRODUCT_ITEMS",
  SAVE_CONTACT_US_FORM = "SAVE_CONTACT_US_FORM",
  SAVE_IS_LOADED_FROM_SUMMARY = "SAVE_IS_LOADED_FROM_SUMMARY",
  MOVE_CART_PRODUCT_SELECTIONS_TO_CART = "MOVE_CART_PRODUCT_SELECTIONS_TO_CART",
  MOVE_CART_OPTIONAL_SELECTIONS_TO_CART = "MOVE_CART_OPTIONAL_SELECTIONS_TO_CART",
  COPY_CART_PRODUCT_TO_CART_PRODUCT_SELECTIONS = "COPY_CART_PRODUCT_TO_CART_PRODUCT_SELECTIONS",
  COPY_CART_OPTIONAL_TO_CART_OPTIONAL_SELECTIONS = "COPY_CART_OPTIONAL_TO_CART_OPTIONAL_SELECTIONS",
  RESTORE_STATE_FROM_SUMMARY = "RESTORE_STATE_FROM_SUMMARY",
  CLEAR_CART = "CLEAR_CART",
  CLEAR_CART_SELECTIONS = "CLEAR_CART_SELECTIONS",
  SAVE_EPISERVER_URLS = "SAVE_EPISERVER_URLS",
}
